import ErrorText from '@atoms/Typographies/Texts/ErrorText';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';

type Props = {
    register: any;
    controlId: string;
    placeholder?: string;
    error?: any;
    setValue?: any;
    getValues?: any;
};

const getExChangeIcon = (startValue: string, endValue: string, exchangeEvent:any) => {
    const showFlag = (startValue && endValue && new Date(startValue).getTime() > new Date(endValue).getTime());
    if (showFlag) {
        return (
            <ExcgangeDateButtonWithStyled onClick={exchangeEvent}>
                <img src='/img/icon/exchange.png' alt='入替' title='入れ替える' />
            </ExcgangeDateButtonWithStyled>
        );
    } else {
        return <></>;
    }
};

const checkDate = (value: string) => {
    const targetDateObj = new Date(value);
    const targetMonth = targetDateObj.getMonth() + 1;
    const targetDate = targetDateObj.getDate();
    const valueList = value.split('-');
    if (targetMonth === parseInt(valueList[1]) && targetDate === parseInt(valueList[2])) {
        return true;
    } else {
        return false;
    }
};

const InputDate = (props: Props) => {
    const { controlId, placeholder, register, error, setValue, getValues } = props;
    const [startValue, setStartValue] = useState(getValues(controlId).start);
    const [endValue, setEndValue] = useState(getValues(controlId).end);
    const checkStartDate = (event: any) => {
        if (setValue && getValues) {
            const startValue = event.target.value;
            setStartValue(startValue);
        }
    };
    const checkEndDate = (event: any) => {
        if (setValue && getValues) {
            const endValue = event.target.value;
            setEndValue(endValue);
        }
    };
    const exchangeEvent = () => {
        setValue(controlId, {
            start: getValues(controlId).end,
            end: getValues(controlId).start
        });
        setStartValue(endValue);
        setEndValue(startValue);
    };
    const reflectValues = () => {
        let _startValue = startValue;
        let _endValue = endValue;
        if (startValue && !checkDate(startValue)) {
            _startValue = '';
            setStartValue(_startValue);
        }
        if (endValue && !checkDate(endValue)) {
            _endValue = '';
            setEndValue(_endValue);
        }
        setValue(controlId, {
            start: _startValue,
            end: _endValue
        });
    };
    
    const exChangeIcon = getExChangeIcon(startValue, endValue, exchangeEvent);
    
    return (
        <Form.Group controlId={controlId}>
            <InputDateSWithStyled>
                <Form.Control
                    type='date'
                    size='sm'
                    placeholder={placeholder}
                    {...register(controlId + '.start')}
                    onChange={(event) => checkStartDate(event)}
                    onBlur={() => reflectValues()}
                />
            </InputDateSWithStyled>
            <BetweenDateWithStyled>～</BetweenDateWithStyled>
            <InputDateSWithStyled>
                <Form.Control
                    type='date'
                    size='sm'
                    placeholder={placeholder}
                    {...register(controlId + '.end')}
                    onChange={(event) => checkEndDate(event)}
                    onBlur={() => reflectValues()}
                />
            </InputDateSWithStyled>
            {exChangeIcon}
            {error && <ErrorText>{error.message}</ErrorText>}
        </Form.Group>
    )
};

const InputDateSWithStyled = styled.span`
    display: inline-block;
`;
const BetweenDateWithStyled = styled.span`
    padding: 0 4px;
`
const ExcgangeDateButtonWithStyled = styled.span`
    margin: 0 0 0 10px;
    cursor: pointer;
    & img {
        width: 20px;
    }
`

export default InputDate;